import script from "./modal-tip.vue?vue&type=script&setup=true&lang=js"
export * from "./modal-tip.vue?vue&type=script&setup=true&lang=js"

import "./modal-tip.vue?vue&type=style&index=0&id=73dc6656&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73dc6656"]])

export default __exports__